import React, { useMemo } from 'react';
import Avatar from '@atlaskit/avatar';
import AvatarGroup from '@atlaskit/avatar-group';
import styled from 'styled-components';

export const AvatarNameView = styled.div`
    p {
        margin-left: 7px;
        margin-top: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: calc(100% - 48px);
    }
    > * {
        display: inline-block;
        vertical-align: middle;
    }
`;

const ProjectsAvatarGroup = ({ virtualComponent }) => {
    const { projects } = virtualComponent || {};

    const avatarGroupData = useMemo(
        () =>
            (projects || []).map((project) => ({
                key: project.jiraProjectId,
                name: project.jiraProjectName,
                src: project.jiraAvatarUrls ? project.jiraAvatarUrls.large : null,
                appearance: 'circle',
                size: 'medium',
                enableTooltip: true,
                onClick: () => window.PlatformAdapter.openProjectUrl(project.jiraProjectKey, project.style),
            })),
        [projects],
    );
    if (!avatarGroupData.length) return null;

    if (avatarGroupData.length === 1) {
        const [entry] = avatarGroupData;
        return (
            <AvatarNameView>
                <Avatar src={entry.src} onClick={entry.onClick} />
                <p>{entry.name}</p>
            </AvatarNameView>
        );
    }

    return <AvatarGroup appearance="stack" size="medium" data={avatarGroupData} maxCount={4} />;
};

export default ProjectsAvatarGroup;
